/**
 * Eddie Borgo Custom Mega Menu
 * Hover intent, carousel, keyboard navigation
 */
(function() {
  'use strict';

  var HOVER_DELAY = 150;
  var LEAVE_DELAY = 200;
  /* Scrolling dismisses an open panel. A few pixels of slack keeps a trackpad
     nudge, a rubber-band bounce or the browser's own scroll restoration from
     counting as intent to scroll away. */
  var SCROLL_CLOSE_THRESHOLD = 5;
  var hoverTimeout = null;
  var leaveTimeout = null;
  var currentOpen = null;
  var scrollAnchorY = window.scrollY;
  var overlay = document.querySelector('[data-eb-mega-overlay]');

  var navItems = document.querySelectorAll('.nav-item.has-eb-mega');
  if (!navItems.length) return;

  /* ===========================
   * Panel open / close
   * =========================== */

  function openPanel(navItem) {
    var switching = currentOpen && currentOpen !== navItem;

    if (switching) {
      // Switching between mega items — skip ALL transitions for instant swap
      var oldPanel = currentOpen.querySelector('[data-eb-mega-panel]');
      var newPanel = navItem.querySelector('[data-eb-mega-panel]');
      if (oldPanel) oldPanel.style.transition = 'none';
      if (newPanel) newPanel.style.transition = 'none';

      closePanel(currentOpen);
    }

    navItem.classList.add('eb-mega--open');

    var panel = navItem.querySelector('[data-eb-mega-panel]');
    if (panel) {
      panel.setAttribute('aria-hidden', 'false');
    }

    // Force-close <details> so Atlantic's details[open] CSS doesn't interfere
    var details = navItem.querySelector('details[data-nav-details]');
    if (details) details.open = false;

    navItem.setAttribute('aria-expanded', 'true');
    currentOpen = navItem;
    scrollAnchorY = window.scrollY;

    if (overlay) {
      /* Position overlay below the header so it only dims page content */
      var header = document.querySelector('.main-header-wrap');
      if (header) {
        var rect = header.getBoundingClientRect();
        overlay.style.top = rect.bottom + 'px';
      }
      overlay.classList.add('is-visible');
    }

    if (switching) {
      // Restore transitions after paint so future open/close still animates
      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          var oldP = oldPanel;
          var newP = panel;
          if (oldP) oldP.style.transition = '';
          if (newP) newP.style.transition = '';
        });
      });
    }
  }

  function closePanel(navItem) {
    if (!navItem) return;
    navItem.classList.remove('eb-mega--open');

    var panel = navItem.querySelector('[data-eb-mega-panel]');
    if (panel) {
      panel.setAttribute('aria-hidden', 'true');
    }

    // Force-close <details> on panel close
    var details = navItem.querySelector('details[data-nav-details]');
    if (details) details.open = false;

    navItem.setAttribute('aria-expanded', 'false');

    if (currentOpen === navItem) {
      currentOpen = null;
      if (overlay) overlay.classList.remove('is-visible');
    }
  }

  function closeAll() {
    navItems.forEach(function(item) {
      closePanel(item);
    });
  }

  /* ===========================
   * Hover intent
   * =========================== */

  navItems.forEach(function(navItem) {
    var panel = navItem.querySelector('[data-eb-mega-panel]');

    // Prevent <details> from toggling — we manage visibility
    var summary = navItem.querySelector('details[data-nav-details] > summary');
    if (summary) {
      summary.addEventListener('click', function(e) {
        e.preventDefault();
        // Navigate to the link URL on click
        var href = summary.getAttribute('href');
        if (href) {
          window.location.href = href;
        }
      });
    }

    navItem.addEventListener('mouseenter', function() {
      clearTimeout(leaveTimeout);
      clearTimeout(hoverTimeout);
      // If a mega menu is already open, switch instantly (no hover delay)
      var delay = currentOpen ? 0 : HOVER_DELAY;
      hoverTimeout = setTimeout(function() {
        hoverTimeout = null;
        openPanel(navItem);
      }, delay);
    });

    navItem.addEventListener('mouseleave', function() {
      clearTimeout(hoverTimeout);
      leaveTimeout = setTimeout(function() {
        closePanel(navItem);
      }, LEAVE_DELAY);
    });

    // Keep panel open when hovering over it
    if (panel) {
      panel.addEventListener('mouseenter', function() {
        clearTimeout(leaveTimeout);
      });

      panel.addEventListener('mouseleave', function() {
        clearTimeout(hoverTimeout);
        leaveTimeout = setTimeout(function() {
          closePanel(navItem);
        }, LEAVE_DELAY);
      });
    }
  });

  /* ===========================
   * Keyboard navigation
   * =========================== */

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && currentOpen) {
      var summary = currentOpen.querySelector('details[data-nav-details] > summary');
      closeAll();
      if (summary) summary.focus();
    }
  });

  /* ===========================
   * Click outside to close
   * =========================== */

  document.addEventListener('click', function(e) {
    if (currentOpen && !currentOpen.contains(e.target)) {
      closeAll();
    }
  });

  /* ===========================
   * Close on scroll
   * =========================== */

  /* The panel is anchored to the header, so once the page moves underneath it
     the menu no longer belongs to what the customer is looking at. Dismiss it,
     and cancel any open that hover intent has queued but not yet fired. */
  window.addEventListener('scroll', function() {
    var y = window.scrollY;

    // Nothing to dismiss — keep the anchor level with the page so the next
    // panel measures from wherever the customer actually is.
    if (!currentOpen && hoverTimeout === null) {
      scrollAnchorY = y;
      return;
    }

    if (Math.abs(y - scrollAnchorY) < SCROLL_CLOSE_THRESHOLD) return;

    clearTimeout(hoverTimeout);
    hoverTimeout = null;
    clearTimeout(leaveTimeout);
    closeAll();
    scrollAnchorY = y;
  }, { passive: true });

  /* ===========================
   * Close on resize below 720px
   * =========================== */

  window.addEventListener('resize', function() {
    if (window.innerWidth < 720 && currentOpen) {
      closeAll();
    }
  });

  /* ===========================
   * Carousel
   * =========================== */

  var carousels = document.querySelectorAll('[data-eb-carousel]');
  carousels.forEach(function(carousel) {
    var track = carousel.querySelector('[data-eb-carousel-track]');
    var prevBtn = carousel.querySelector('[data-eb-carousel-prev]');
    var nextBtn = carousel.querySelector('[data-eb-carousel-next]');
    var slides = track ? track.children : [];

    if (!track || slides.length === 0) return;

    var loop = carousel.getAttribute('data-eb-carousel-loop') === 'true';
    var position = 0;

    function getSlideWidth() {
      if (!slides[0]) return 0;
      var style = window.getComputedStyle(track);
      var gap = parseInt(style.gap) || 20;
      return slides[0].offsetWidth + gap;
    }

    function getMaxPosition() {
      var trackWidth = track.scrollWidth;
      var viewportWidth = track.parentElement.offsetWidth;
      return Math.max(0, trackWidth - viewportWidth);
    }

    function updateArrows() {
      if (loop) {
        // Loop mode — arrows always enabled when scrollable
        var canScroll = getMaxPosition() > 0;
        if (prevBtn) prevBtn.disabled = !canScroll;
        if (nextBtn) nextBtn.disabled = !canScroll;
      } else {
        if (prevBtn) prevBtn.disabled = position <= 0;
        if (nextBtn) nextBtn.disabled = position >= getMaxPosition();
      }
    }

    function scrollBy(direction) {
      var slideWidth = getSlideWidth();
      var step = slideWidth * 3;
      var maxPos = getMaxPosition();

      var slideW = getSlideWidth();
      if (direction === 'next') {
        var remaining = maxPos - position;
        if (loop && remaining < slideW) {
          position = 0;
        } else {
          position = Math.min(maxPos, position + step);
        }
      } else {
        if (loop && position < slideW) {
          position = maxPos;
        } else {
          position = Math.max(0, position - step);
        }
      }

      track.style.transform = 'translateX(-' + position + 'px)';
      updateArrows();
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        scrollBy('prev');
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        scrollBy('next');
      });
    }

    // Initial arrow state
    updateArrows();

    // Recalculate on resize
    window.addEventListener('resize', function() {
      position = 0;
      track.style.transform = 'translateX(0)';
      updateArrows();
    });
  });

})();
